var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"gps-button",attrs:{"depressed":"","tile":"","icon":"","color":"#1474CE"},on:{"click":_vm.moveCurrentLocation}},[(_vm.isLoading)?_c('v-progress-circular',{attrs:{"indeterminate":""}}):_c('v-icon',[_vm._v("mdi-crosshairs-gps")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }